<template>
    <div class="form-group" :class="cssClasses">
        <label :for="'input' + _uid">{{ label }}</label>
        <input :type="type"
               :id="'input' + _uid"
               :name="'input' + _uid"
               @input="inputChanged"
               v-model="value"
               v-validate="validations"
               :data-vv-as="label"
               class="form-control" />
        <span class="text-danger" v-if="errors.has('input' + _uid)">{{ errors.first('input' + _uid) }}</span>
    </div>
</template>

<script>
    import { ComponentSize } from '../../models/enums';

    export default {
        inject: ['$validator'],
        props: {
            type: {
                type: String,
                default: 'text'
            },
            value: String,
            label: {
                type: String,
                default: ''
            },
            isRequired: {
                type: Boolean,
                default: false
            }
            // TODO: min and max for validation
        },
        data() {
            return {
                cssClasses: ComponentSize.Medium,
                validations: ''
            }
        },
        methods: {
            inputChanged(event) {
                this.$emit('input', event.target.value);
            },
            addValidations() {
                // TODO: Check validation from props and add validation classes for VeeValidate
                if (this.isRequired) {
                    if (this.validations.length > 0) {
                        this.validations += '|';
                    }
                    this.validations = 'required';
                }
            }
        },
        mounted() {
            this.addValidations();
        }
    }
</script>

<style scoped>

</style>
